export default {
  // Hero
  heroTag: "Afrique de l'Est · Rwanda · IDE",
  heroTitle1: "Votre Passage vers",
  heroTitle2: "les Marchés",
  heroTitle3: "à la Plus Forte Croissance",
  heroTitle4: "d'Afrique de l'Est",
  heroSubtitle: "Votre partenaire de confiance pour l'investissement, la conformité et la facilitation des affaires en Afrique de l'Est",
  heroCta1: "Créer Votre Entreprise",
  heroCta2: "Explorer les Opportunités",
  heroCta3: "Obtenir un Support d'Appels d'Offres",
  heroStat1: "Entreprises Enregistrées",
  heroStat2: "Marchés d'Afrique de l'Est",
  heroStat3: "Taux de Conformité",
  heroStat4: "Années d'Expérience",
  heroScroll: "Défiler",

  // What We Do
  whatWeDoTag: "Notre Expertise",
  whatWeDoTitle: "Ce que nous",
  whatWeDoTitleAccent: "Faisons",
  whatWeDoDesc: "AIP fournit un support complet aux entreprises qui entrent ou s'étendent en Afrique de l'Est — de la constitution juridique à la croissance du marché.",
  pillar1Title: "Enregistrement & Conformité d'Entreprise",
  pillar1Desc: "Support complet d'incorporation pour les entreprises étrangères au Rwanda et en Afrique de l'Est, avec une gestion complète de la conformité réglementaire.",
  pillar2Title: "Facilitation de l'Investissement",
  pillar2Desc: "Connexion des investisseurs internationaux avec des opportunités à forte croissance dans les secteurs les plus dynamiques de l'Afrique de l'Est.",
  pillar3Title: "Opportunités Commerciales",
  pillar3Desc: "Opportunités d'investissement et de partenariat triées sur le volet au Rwanda et en Afrique de l'Est, adaptées à votre secteur et vos objectifs.",
  pillar4Title: "Services de Support d'Appels d'Offres",
  pillar4Desc: "Préparation complète des offres, acquisition de documents, garanties et représentation pour les appels d'offres publics et privés.",

  // Featured Opportunities
  opportunitiesTag: "Opportunités en Direct",
  opportunitiesTitle: "Opportunités d'Investissement",
  opportunitiesTitleAccent: "Actuelles",
  opportunitiesDesc: "Opportunités d'investissement vérifiées et triées sur le volet au Rwanda et dans les secteurs les plus dynamiques de l'Afrique de l'Est.",
  oppStatus: "Ouvert",
  oppExpressInterest: "Manifester un Intérêt",

  // Regulated Sectors
  sectorsTag: "Expertise Spécialisée",
  sectorsTitle1: "Secteurs",
  sectorsTitle2: "Réglementés que Nous Servons",
  sectorsDesc: "Support de conformité spécialisé dans les industries à plus forte croissance de l'Afrique de l'Est — licences, certifications et permis gérés.",
  sectorsQuote: "AIP combine une connaissance approfondie de la réglementation, un réseau local puissant et une approche pratique pour assurer la réussite de votre entreprise.",
  sectorHealth: "Services de Santé",
  sectorHealthDesc: "Médicaments, dispositifs médicaux, établissements de santé",
  sectorHealthDetail: "Hôpitaux, cliniques et autres établissements de santé permis/licence de travail; acquisition de licence de détaillant de médicaments pour humains; acquisition de licence de grossiste de médicaments pour humains; acquisition de licence de fournisseur de dispositifs médicaux pour humains; enregistrement des médicaments; enregistrement des dispositifs médicaux; acquisition de licence d'importation de produits médicaux et dispositifs médicaux; acquisition de licence d'exportation de produits médicaux et dispositifs médicaux",
  showMore: "Voir plus",
  showLess: "Voir moins",
  close: "Fermer",
  sectorInfrastructure: "Infrastructure",
  sectorInfrastructureDesc: "Routes, énergie, services publics, travaux publics",
  sectorManufacturing: "Manufacture",
  sectorManufacturingDesc: "Usines, licences d'import/export",
  sectorRealEstate: "Immobilier & Construction",
  sectorRealEstateDesc: "Développement immobilier, permis, licences",
  sectorMining: "Mines",
  sectorMiningDesc: "Minéraux, extraction, transformation",
  sectorTourism: "Tourisme",
  sectorTourismDesc: "Hôtellerie, voyage, licences touristiques",
  sectorAgribusiness: "Agrobusiness",
  sectorAgribusinessDesc: "Production alimentaire, transformation, exportation",
  sectorEducation: "Éducation",
  sectorEducationDesc: "Écoles, universités, plateformes EdTech",
  sectorFinance: "Services Financiers",
  sectorFinanceDesc: "Banques, assurances, licences fintech",
  sectorFood: "Agroalimentaire",
  sectorFoodDesc: "Sécurité alimentaire, certifications, permis",
  badgeLicensed: "Agréé",
  badgeCompliant: "Conforme",
  badgeTrusted: "Fiable",

  // Why Choose AIP
  whyChooseTag: "Pourquoi Choisir AIP",
  whyChooseTitle1: "Votre Passage vers les Marchés",
  whyChooseTitle2: "à la Plus Forte Croissance",
  whyChooseTitle3: "d'Afrique de l'Est",
  whyChooseTitle4: "",
  whyChooseDesc: "AIP combine une connaissance approfondie de la réglementation, un réseau local puissant et une approche pratique pour assurer la réussite de votre entreprise au Rwanda et en Afrique de l'Est. Nous naviguons la complexité pour que vous n'ayez pas à le faire.",
  tagLocal: "Expertise Locale",
  tagSpeed: "Rapidité & Efficacité",
  tagFull: "Conformité Complète",
  tagNetwork: "Réseau de Confiance",
  whyCta: "En Savoir Plus sur Nous",

  // Sector Support Form
  sectorFormTitle: "Demander un Support Sectoriel",
  sectorFormSubtitle: "Dites-nous quel support vous avez besoin dans ce secteur et nos spécialistes vous contacteront sous 24 heures.",
  sectorFormSectorLabel: "Secteur",
  sectorFormSuccessTitle: "Demande Soumise!",
  sectorFormSuccessBody: "Nos spécialistes sectoriels vous répondront dans les 24 heures.",
  sectorFormSubmit: "Soumettre la Demande",

  // CTA
  ctaTag: "Commencez Aujourd'hui",
  ctaTitle: "Prêt à pénétrer les marchés à la plus forte croissance d'Afrique de l'Est?",
  ctaDesc: "De l'enregistrement de l'entreprise à la participation aux appels d'offres — AIP est votre partenaire complet pour réussir au Rwanda et en Afrique de l'Est.",
  ctaBtn1: "Contactez AIP Aujourd'hui",
  ctaBtn2: "Explorer les Services",
};